var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGuardianBlue = function SvgGuardianBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#guardian-blue_svg__guardian-blue_svg__clip0_1600_385816)",
    stroke: "#1E1E5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.001 2.5A10 10 0 0017.084 5a9.999 9.999 0 01-7.083 12.5A10 10 0 012.918 5 10 10 0 0010 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.168 9.167a.833.833 0 101.667 0 .833.833 0 00-1.667 0zM10 10v2.083"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guardian-blue_svg__guardian-blue_svg__clip0_1600_385816"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGuardianBlue;